// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-container {
  /* min-height: 500px; */
  flex: 1;
  overflow: auto;
}

.ql-tooltip {
  left: 0 !important;
}
.ql-picker {
  line-height: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/components/common/RichTextEditor.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".ql-container {\n  /* min-height: 500px; */\n  flex: 1;\n  overflow: auto;\n}\n\n.ql-tooltip {\n  left: 0 !important;\n}\n.ql-picker {\n  line-height: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
